export let SalaryComponentsConstants = {
  payoutFrequencyList: ["Monthly", "Quarterly", "Bi-annually", "Annually"],
  roundOffList: [
    { id: "RoundOff", name: "Nearest to 1 Rs" },
    { id: "NoRound", name: "No Round Off" },
    { id: "NearestTo10", name: "Nearest to 10 Rs" },
    { id: "RoundUp", name: "Round Up To rupee" }
  ],
  payFrequencyList: [
    { name: "Daily", id: "DAILY" },
    { name: "Weekly", id: "WEEKLY" },
    { name: "Monthly", id: "MONTHLY" },
    { name: "Quarterly", id: "QUARTERLY" }
  ],
  transactionTypeList: [
    { name: "Deduction", id: "DEDUCTION" },
    { name: "Earning", id: "EARNING" },
    { name: "None", id: "NONE" }
  ],
  calculationTypeList: ["Formula", "Flat"/*, "Slab"*/],
  payDaysmonthList: [
    {
      name: "Fixed base days",
      id: "Fixed"
    },
    {
      name: "Previous month calendar days",
      id: "Previous"
    },
    {
      name: "Current month calendar days",
      id: "Current"
    }
  ]
};
export let criteriaObj = {
  paygroupCriteria: [
    "Location",
    "Salary Band",
    "Grade",
    "Cost Centre",
    "Department",
    "Designations"
  ],
  probationCriteria: ["Location", "Designation", "Grade"],
  reportCriteria: ["Band", "Cost Centre", "Department", "Grade", "Location"]
};
export let probationObj = {
  probationTypes: [
    { name: "Days", id: "days" },
    { name: "Months", id: "months" }
  ]
};
export let ErrorMesages = {
  nameError: "Please enter Name"
};

export let TdsConstants = {
  tdsList: [
    { name: "No Overrides", id: "NO_OVERRIDE" },
    { name: "Consider Zero TDS", id: "ZERO" },
    { name: "Use Previous Month TDS", id: "LAST_MONTH" },
    { name: "Compute For This Month", id: "FIXED" }
  ]
};
export let retirementConstants = {
  retirementCriteriaOptions: [
    { name: "On The Date of Birthday", value: "date_of_birthdate" },
    {
      name: "Last Working Day of Birthday Month",
      value: "end_of_birth_month"
    },
    { name: "Specific Date", value: "specific_date" }
  ]
};
export let monthOptionsObj = {
  onlyMonths: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  yearMonths: [
    {name: "January", id: 1},
    {name: "February", id: 2},
    {name: "March", id: 3},
    {name: "April", id: 4},
    {name: "May", id: 5},
    {name: "June", id: 6},
    {name: "July", id: 7},
    {name: "August", id: 8},
    {name: "September", id: 9},
    {name: "October", id: 10},
    {name: "November", id: 11},
    {name: "December", id: 12},
  ],
  monthListForFinancialYear: [
    { name: "April", value: "apr", index: 3 },
    { name: "May", value: "may", index: 4 },
    { name: "June", value: "jun", index: 5 },
    { name: "July", value: "jul", index: 6 },
    { name: "August", value: "aug", index: 7 },
    { name: "September", value: "sep", index: 8 },
    { name: "October", value: "oct", index: 9 },
    { name: "November", value: "nov", index: 10 },
    { name: "December", value: "dec", index: 11 },
    { name: "January", value: "jan", index: 0 },
    { name: "February", value: "feb", index: 1 },
    { name: "March", value: "mar", index: 2 }
  ]
};

export let LoginSettingsConstants = {
  otpTypeList: [
    { name: "Email", id: "EMAIL" },
    { name: "Phone", id: "MOBILE" },
    { name: "Both", id: "BOTH" }
  ]
};

export let PayrollComputationConstants = {
  payDaysmonthList: [
    { name: "Fixed base days", id: "Fixed" },
    { name: "Previous month calendar days", id: "Previous" },
    { name: "Current month calendar days", id: "Current" }
  ]
};

export let PayrollSettingsConstants = {
  payFrequencyList: [
    { name: "Monthly", id: "MONTHLY" },
    { name: "Quarterly", id: "QUARTERLY" },
    { name: "Weekly", id: "WEEKLY" },
    { name: "Daily", id: "DAILY" }
  ]
};

export let SalaryStructureConstants = {
  criteriaList: [
    { name: "Location" },
    { name: "Cost Centre" },
    { name: "Designations" },
    { name: "Grade" },
    { name: "Employee Category" },
    { name: "Salary Band" },
    { name: "Department" }
  ]
};

export let HoldStopReleaseSalary = {
    criteriaList: [{ name: 'Bands' }, { name: 'Cost Centre' }, { name: 'Locations' }, { name: 'Department' }],
    salaryStatusList: [{ name: "On Hold" }, { name: "Stopped" }, { name: "Normal" }, { name: "All" }]
}

export let ReviseSalaryConstants = {
    revisedByOptions: [{name:"Percentage"}, {name:"Flat Amount"}],
    actionTypes: [{name:"Add"}, {name:"Subtract"}, {name:"Replace"}],
    applyToOptions: [{name:"CTC"},{name:"Gross Salary"},{name:"Basic+DA(If DA applicable)"}],
    revisionTypeOptions: [{name:"CTC"}, {name:"Gross"}],
    criteriaList: [{name:"Designation"}, {name:"Grades"}, {name:"Bands"}, {name:"Location"}],
    statusList: [{name:"Active"}, {name:"Scheduled"},{name:"Completed"}, {name:"Revoked"}],
    revisedByOptionsNew: [{name:"Hike in %"}, {name:"Hike in value"}, {name:"New value"},],
}

export let commonData = {
  relationshipList: [
    "Father",
    "Mother",
    "Brother",
    "Sister",
    "Aunt",
    "Uncle",
    "Son",
    "Daughter",
    "Grand Father",
    "Grand Mother"
  ]
};
export let LossReverseLossOfPayConstants = {
  lopRLopTypeList: [{ name: "LOP" }, { name: "RLOP" }]
};
